import React from 'react';
import moment from 'moment';
import { ColumnsType } from 'antd/lib/table';

import { IPessoaProps } from '../../types';
import { TableButtonDelete } from './TableButtonDelete';
import { TableButtonEdit } from './TableButtonEdit';
import { TableButtonView } from './TableButtonView';
import { TableButtonRestore } from './TableButtonRestore';

interface ITableColumnControllerProps {
  handleDeleteFunction: (pessoaId: string) => Promise<void>;
  handleRestoreFunction: (pessoaId: string) => Promise<void>;
  refetch: () => void;
  dataList?: IPessoaProps[];
}

export function TableColumnController({
  handleDeleteFunction,
  handleRestoreFunction,
  refetch,
  dataList,
}: ITableColumnControllerProps) {
  const columns: ColumnsType<IPessoaProps> = [
    {
      title: 'Nome',
      dataIndex: 'nome',
      sorter: true,
    },

    {
      title: 'Status',
      dataIndex: 'status',
      render: (_, row: any) => (
        <span
          style={{
            color: row.status === 1 ? '#20C9A5' : '#faad14',
            background: row.status === 1 ? '#E2F4F0' : '#fffbe6',
            border: `0px solid ${row.status === 1 ? '#b7eb8f' : '#ffe58f'}`,
            padding: '3px 10px',
            borderRadius: 40,
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            boxSizing: 'border-box',
            fontVariant: 'tabular-nums',
            listStyle: 'none',
            fontFeatureSettings: 'tnum',
            display: 'inline-block',
            height: 'auto',
            fontSize: '12px',
            lineHeight: '20px',
            whiteSpace: 'nowrap',
            transition: 'all 0.3s',
          }}
        >
          {row.status === 1 ? 'Ativo' : 'Inativo'}
        </span>
      ),
    },

    {
      title: 'Ações',
      dataIndex: 'actions',
      render: (_, item) => {
        return (
          <div className="table-actions">
            {item.status == '0' ? (
              <TableButtonRestore handleRestoreFunction={handleRestoreFunction} contactId={String(item.id)} />
            ) : (
              <>
                <TableButtonView pessoaId={String(item.id)} refetch={refetch} data={item} />
                <TableButtonEdit pessoaId={String(item.id)} refetch={refetch} data={item} />

                <TableButtonDelete handleDeleteFunction={handleDeleteFunction} pessoaId={String(item.id)} />
              </>
            )}
          </div>
        );
      },
    },
  ];

  const data: any[] = [];
  console.log(dataList);

  dataList?.forEach(item => {
    data.push({
      key: item.id,
      id: item.id,

      nome: item.nome,

      createdAt: moment(item.createdAt).format('DD/MM/YYYY'),

      idSexo: String(item.idSexo),
      idEstadoCivil: String(item.idEstadoCivil),
      idNacionalidade: String(item.idNacionalidade),
      cpf: item.cpf,
      rg: item.rg,
      endereco: item.endereco,
      numero: item.numero,
      complemento: item.complemento,
      cep: item.cep,
      bairro: item.bairro,
      cidade: item.cidade,
      uf: item.uf,
      tel1: item.tel1,
      tel2: item.tel2,
      status: item.status,
    });
  });

  return { columns, data };
}
